/**
 * Module dependencies.
 */

import { axiosInstance, getApiEndpoint } from 'src/core/requests';
import { snakeCaseObjectKeys } from 'src/core/utils/objects';

/**
 * Export`CheckUpFormData` type.
 */

export type CheckUpFormData = {
  date: string;
  date_of_birth: string;
  email: string;
  name: string;
  observations: string;
  phone: string;
  preconditions: string;
  promoCode?: string;
  recaptcha_token: string;
  subscribe_to_newsletter: boolean;
  time: string;
};

/**
 * Export `postCheckUp` request.
 */

export async function postCheckUp(data: CheckUpFormData) {
  const response = await axiosInstance.post(
    getApiEndpoint('checkUp'),
    snakeCaseObjectKeys(data)
  );

  return response?.data?.data;
}
